import type { ApiDataShape, ApiErrorShape } from '../shared/types'

export class ApiClientError extends Error {
  readonly code: string
  readonly status: number
  readonly details?: unknown

  constructor(status: number, body: ApiErrorShape['error']) {
    super(body.message)
    this.name = 'ApiClientError'
    this.status = status
    this.code = body.code
    this.details = body.details
  }
}

export async function apiRequest(path: string, init: RequestInit = {}): Promise<Response> {
  const headers = new Headers(init.headers)
  if (init.body && !(init.body instanceof FormData) && !headers.has('content-type')) {
    headers.set('content-type', 'application/json')
  }
  let response: Response
  try {
    response = await fetch(path, { ...init, headers, credentials: 'same-origin' })
  } catch {
    throw new ApiClientError(0, { code: 'NETWORK_ERROR', message: '网络连接失败，请检查连接后重试' })
  }

  if (!response.ok) {
    let error: ApiErrorShape['error'] = { code: 'REQUEST_FAILED', message: '请求失败' }
    try {
      const body = (await response.json()) as ApiErrorShape
      if (body.error) error = body.error
    } catch {
      // Use the stable fallback for non-JSON failures.
    }
    throw new ApiClientError(response.status, error)
  }
  return response
}

export async function apiFetch<T>(path: string, init: RequestInit = {}): Promise<T> {
  const response = await apiRequest(path, init)

  let body: ApiDataShape<T> | ApiErrorShape
  try {
    body = (await response.json()) as ApiDataShape<T> | ApiErrorShape
  } catch {
    throw new ApiClientError(response.status, {
      code: 'RESPONSE_INVALID',
      message: '服务器响应异常，请稍后重试',
    })
  }
  if ('error' in body) {
    const error = 'error' in body ? body.error : { code: 'REQUEST_FAILED', message: '请求失败' }
    throw new ApiClientError(response.status, error)
  }
  return body.data
}
